// Navigasi keyboard ala Excel untuk tabel input sederhana (mis. popup "Tambah ke Trf").
// Setiap input diberi data-grid-row (index baris) dan data-grid-col (nama kolom),
// dan dibungkus elemen dengan atribut data-excel-grid.
//
// Enter / Shift+Enter: turun / naik, Tab / Shift+Tab: kanan / kiri (lanjut ke baris berikut),
// panah atas/bawah: pindah baris, panah kiri/kanan: pindah kolom kalau kursor di ujung teks
// atau isi sel terblok. Enter tidak pernah men-submit form.

const selectInput = (input) => {
  try {
    input.select();
  } catch (error) {
    // input type="date" tidak mendukung select().
  }
};

export const focusExcelGridCell = (gridElement, rowIndex, column) => {
  const target = gridElement?.querySelector(`[data-grid-row="${rowIndex}"][data-grid-col="${column}"]`);
  if (!target || target.disabled) return false;
  target.focus();
  target.scrollIntoView({ block: "nearest", inline: "nearest" });
  window.requestAnimationFrame(() => selectInput(target));
  return true;
};

const getCaretInfo = (input) => {
  try {
    const { selectionStart, selectionEnd, value } = input;
    if (selectionStart === null || selectionStart === undefined) return null;
    return {
      atStart: selectionStart === 0 && selectionEnd === 0,
      atEnd: selectionStart === value.length && selectionEnd === value.length,
      allSelected: selectionStart === 0 && selectionEnd === value.length,
    };
  } catch (error) {
    return null;
  }
};

export const handleExcelGridKeyDown = (event, columns) => {
  const input = event.currentTarget;
  const rowIndex = Number(input.dataset.gridRow);
  const columnIndex = columns.indexOf(input.dataset.gridCol);
  if (Number.isNaN(rowIndex) || columnIndex < 0) return;

  const gridElement = input.closest("[data-excel-grid]");
  const lastColumnIndex = columns.length - 1;
  const moveTo = (nextRow, nextColumnIndex) => {
    event.preventDefault();
    focusExcelGridCell(gridElement, nextRow, columns[nextColumnIndex]);
  };

  switch (event.key) {
    case "Enter":
      moveTo(rowIndex + (event.shiftKey ? -1 : 1), columnIndex);
      break;
    case "ArrowDown":
      moveTo(rowIndex + 1, columnIndex);
      break;
    case "ArrowUp":
      moveTo(rowIndex - 1, columnIndex);
      break;
    case "Tab":
      if (event.shiftKey) {
        if (columnIndex > 0) moveTo(rowIndex, columnIndex - 1);
        else if (rowIndex > 0) moveTo(rowIndex - 1, lastColumnIndex);
      } else if (columnIndex < lastColumnIndex) moveTo(rowIndex, columnIndex + 1);
      else if (!focusExcelGridCell(gridElement, rowIndex + 1, columns[0])) {
        // Baris terakhir: biarkan Tab keluar dari tabel (ke tombol Simpan) seperti biasa.
        return;
      } else event.preventDefault();
      break;
    case "ArrowLeft":
    case "ArrowRight": {
      const caret = getCaretInfo(input);
      const goLeft = event.key === "ArrowLeft";
      const canLeave = !caret || caret.allSelected || (goLeft ? caret.atStart : caret.atEnd);
      if (!canLeave) return;
      const nextColumnIndex = columnIndex + (goLeft ? -1 : 1);
      if (nextColumnIndex >= 0 && nextColumnIndex <= lastColumnIndex) moveTo(rowIndex, nextColumnIndex);
      break;
    }
    default:
      break;
  }
};
